import { Component } from '@angular/core';
import { PuntoPage } from 'src/app/models/entidad-page.interface';
import { HttpPaginacion, Paginar } from 'src/app/models/http-paginacion.interface';
import { AdministradorService } from 'src/app/services/administrador.service';
@Component({
    selector: 'app-puntos',
    templateUrl: './puntos.component.html',
    styleUrls: ['./puntos.component.scss']
})
export class PuntosComponent {
    first: number = 0;
    rows: number = 10;
    totalRecords: number = 120;
    puntosPageInformacion: HttpPaginacion<PuntoPage> | undefined;
    puntoPage: PuntoPage[] = [];
    constructor(private adiministradorService: AdministradorService) {
        this.obtenerInformacion(1);
    }

    obtenerInformacion(page: number): void {
        this.adiministradorService.puntos(page)
            .subscribe({
                next: (resp) => {
                    this.puntosPageInformacion = resp;
                    this.puntoPage = resp.data;

                    this.first = (resp.current_page - 1) * resp.per_page;
                    this.rows = resp.per_page;
                    this.totalRecords = resp.total;
                },
                error: (err) => console.log(err)
            })
    }

    onPageChange(event: any) {
        const paginar: Paginar = <Paginar>event;
        const paginaActual = paginar.page + 1;
        this.obtenerInformacion(paginaActual);

    }
    exportExcel(): void { }
}
